import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs/operators';
import type { AppState } from '../store/app.state';
import { selectCurrentTenant } from '../store/tenant/tenant.selectors';
import { selectUser } from '../store/auth/auth.selectors';
import { combineLatest } from 'rxjs';

export function createTenantVerticalGuard(expected: 'food' | 'personal_care'): CanActivateFn {
  return () => {
    const store = inject(Store<AppState>);
    const router = inject(Router);

    return combineLatest([store.select(selectCurrentTenant), store.select(selectUser)]).pipe(
      take(1),
      map(([tenant, user]) => {
        if (!tenant && user) {
          return true;
        }
        if (tenant?.vertical === expected) {
          return true;
        }
        void router.navigate(['/dashboard']);
        return false;
      })
    );
  };
}

export const foodVerticalGuard = createTenantVerticalGuard('food');
export const personalCareVerticalGuard = createTenantVerticalGuard('personal_care');
